/*
 *  ************************************************************************
 *  *  © [2015 - 2020] Quintype Technologies India Private Limited
 *  *  All Rights Reserved.
 *  *************************************************************************
 */
import React from 'react';
import get from 'lodash/get';
import PropTypes from 'prop-types';
import { WidgetComponent } from '../../Widget';
import { customCodeWithShortcode } from '../../../../utils/decodeCustomCode';
import './widget.m.css';
import { useSelector } from 'react-redux';

function CustomWidgetRow ({ metadata = {}, storyId }) {
  const {
    customCode: codeToInject,
    targetingId,
    aheadNxtWidgetPlaceholderHeight: widgetHeightMobile = '',
    widgetHeightDesktop = ''
  } = get(metadata, ['config'], {});

  if (!codeToInject) return null;

  const lightRows = useSelector(state =>
    get(state, ['qt', 'config', 'pagebuilder-config', 'home', 'lightRows'], false)
  );
  const pageType = useSelector(state => get(state, ['qt', 'pageType'], ''));

  const rowId = get(metadata, ['rowId'], '');
  const id = targetingId && storyId ? `widget-${targetingId}-${storyId}` : `widget-${targetingId || rowId}`;
  const shouldRenderWidgetWrapper = lightRows && pageType === 'home-page';

  if (shouldRenderWidgetWrapper) {
    return (
      <div
        id={id}
        styleName="customWidgetWrapper widget"
        style={{
          '--widget-height-mobile': `${widgetHeightMobile || 50}px`,
          '--widget-height-desktop': `${widgetHeightDesktop || 50}px`
        }}
      ></div>
    );
  } else {
    const newId = `custom-${id}`;
    const widgetCode = customCodeWithShortcode(codeToInject, newId);
    return (
      <div
        id={id}
        styleName="customWidgetWrapper widget"
        style={{
          '--widget-height-mobile': `${widgetHeightMobile || 50}px`,
          '--widget-height-desktop': `${widgetHeightDesktop || 50}px`
        }}
      >
        <WidgetComponent widgetValue={`<div>${widgetCode}</div>`} />
      </div>
    );
  }
}

CustomWidgetRow.propTypes = {
  metadata: PropTypes.object,
  storyId: PropTypes.string
};

export { CustomWidgetRow };
